<template>
  <div class="team wh100">
    <el-card
      class="left-box wh100"
      body-style="height:calc(100% - 49px);overflow-y:auto;padding:0px 20px;padding-bottom: 0px;"
      v-loading="dataLoading"
    >
      <div slot="header" class="clearfix" style="height: 29px">
        <!-- <span style="font-size: 18px; font-weight: bold">项目供应商</span> -->
        <el-button
          type="primary"
          size="mini"
          icon="el-icon-plus"
          style="float: right; margin-right: 10px"
          @click="openDialog"
          >增加供应商</el-button
        >
        <!-- <el-button
          type="primary"
          size="mini"
          icon="el-icon-download"
          style="float: right; margin-right: 10px"
          @click="getExcel"
          >导出</el-button
        > -->
      </div>
      <div style="height: calc(100% - 10px)">
        <el-table
          :data="data"
          style="width: 100%"
          row-key="Id"
          height="calc(100%)"
          v-loading="dataLoading"
        >
          <el-table-column
            type="index"
            label="序号"
            width="55"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="cVenName"
            label="供应商名称"
            width="360"
            sortable
            show-overflow-tooltip
          />
          <el-table-column
            prop="SupplierClassificationName"
            label="供应商类型"
            width="120"
            sortable
            show-overflow-tooltip
          />
          <el-table-column
            prop="cVenPerson"
            label="联系人"
            width="150"
            sortable
            show-overflow-tooltip
          />
          <el-table-column
            prop="cVenPhone"
            label="联系电话"
            width="150"
            sortable
            show-overflow-tooltip
          />
          <el-table-column
            prop="EquipmentClassificationName"
            label="设备分类"
            width="350"
            sortable
          >
            <template slot-scope="scope">
              <el-tooltip
                effect="dark"
                placement="top"
                :disabled="!scope.row.EquipmentClassificationName || scope.row.EquipmentClassificationName.length <= 30"
              >
                <div slot="content" class="custom-tooltip-content">
                  <div
                    v-for="(item, index) in formatTooltipContent(scope.row.EquipmentClassificationName)"
                    :key="index"
                    class="tooltip-item"
                  >
                    <span class="tooltip-icon-square"></span>
                    <span>{{ item }}</span>
                  </div>
                </div>
                <div class="ellipsis-cell">
                  {{ scope.row.EquipmentClassificationName || '-' }}
                </div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            prop="SupplierQualificationName"
            label="项目资料类型"
            width="350"
            sortable
          >
            <template slot-scope="scope">
              <el-tooltip
                effect="dark"
                placement="top"
                :disabled="!scope.row.SupplierQualificationName || scope.row.SupplierQualificationName.length <= 30"
              >
                <div slot="content" class="custom-tooltip-content">
                  <div
                    v-for="(item, index) in formatTooltipContent(scope.row.SupplierQualificationName)"
                    :key="index"
                    class="tooltip-item"
                  >
                    <span class="tooltip-icon-square"></span>
                    <span>{{ item }}</span>
                  </div>
                </div>
                <div class="ellipsis-cell">
                  {{ scope.row.SupplierQualificationName || '-' }}
                </div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            prop="SupplierTypeName"
            label="资质资料类型"
            width="350"
            sortable
          >
            <template slot-scope="scope">
              <el-tooltip
                effect="dark"
                placement="top"
                :disabled="!scope.row.SupplierTypeName || scope.row.SupplierTypeName.length <= 30"
              >
                <div slot="content" class="custom-tooltip-content">
                  <div
                    v-for="(item, index) in formatTooltipContent(scope.row.SupplierTypeName)"
                    :key="index"
                    class="tooltip-item"
                  >
                    <span class="tooltip-icon-square"></span>
                    <span>{{ item }}</span>
                  </div>
                </div>
                <div class="ellipsis-cell">
                  {{ scope.row.SupplierTypeName || '-' }}
                </div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            prop="UserName"
            label="创建人"
            width="100"
            show-overflow-tooltip
            sortable
            fixed="right"
          />
          <el-table-column
            prop="CreateTime"
            label="创建时间"
            width="150"
            show-overflow-tooltip
            sortable
            fixed="right"
          >
            <template slot-scope="scope">
              {{
                scope.row.CreateTime
                  ? moment(scope.row.CreateTime).format('YYYY-MM-DD HH:mm:ss')
                  : ''
              }}
            </template>
          </el-table-column>
          <el-table-column prop="op" label="操作" width="240" fixed="right">
            <template slot-scope="scope">
              <el-button
                type="text"
                icon="el-icon-share"
                size="mini"
                v-if="scope.row.Level == 1"
                @click="openTokenInfo(scope.row)"
                >邀请码</el-button
              >
              <el-button
                type="text"
                icon="el-icon-edit-outline"
                size="mini"
                style="color: #e6a23c"
                v-if="scope.row.Level == 1"
                @click="editItem(scope.row)"
                >编辑</el-button
              >
              <el-button
                type="text"
                icon="el-icon-tickets"
                size="mini"
                style="color: #67c23a"
                @click="TreeClassOpen(scope.row)"
                v-if="scope.row.Level == 1"
                >分配</el-button
              >
              <!-- <el-button
                    type="text"
                    icon="el-icon-tickets"
                    size="mini"
                    style="color: #67c23a"
                    @click="ItemInfo(scope.row)"
                    >详情</el-button
                  > -->
              <el-button
                type="text"
                icon="el-icon-delete"
                size="mini"
                style="color: red"
                v-if="scope.row.Level == 1"
                @click="delUser(scope.row)"
                >移除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-card>

    <el-dialog title="邀请码信息" :visible.sync="dialogVisible" width="600px">
      <div v-loading="shareTokenLoading">
        <div
          style="
            display: flex;
            align-items: center;
            justify-content: space-between;
          "
        >
          <div style="font-weight: bold; color: #000; font-size: 18px">
            点击红色链接复制
          </div>
          <div>
            <el-button type="primary" @click="getTokenInfo(1)"
              >重置邀请码</el-button
            >
          </div>
        </div>
        <div style="font-weight: bold; font-size: 16px; margin-top: 20px">
          邀请码信息：
        </div>
        <div
          style="margin-top: 10px; color: red; cursor: pointer"
          @click="copyTEXT(shareToken)"
        >
          {{ shareToken }}
        </div>
        <div style="margin-top: 20px; font-weight: bold; font-size: 16px">
          供应商填写资料地址：
        </div>
        <div
          style="margin-top: 10px; color: red; cursor: pointer"
          @click="copyTEXT(downloadUrl)"
        >
          {{ downloadUrl }}
        </div>
        <div style="margin-top: 20px; font-weight: bold; font-size: 16px">
          <el-button type="warning" @click="copyValue">复制邀请链接</el-button>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>

    <!-- <el-dialog
      title="供应商详细信息"
      :visible.sync="InfoVisible"
      width="50%"
      top="5vh"
    >
      <div>
        <el-descriptions :column="1" border>
          <el-descriptions-item label="供应商名称">{{
            item.cVenName || '暂无数据'
          }}</el-descriptions-item>

          <el-descriptions-item label="联系人">{{
            item.cVenPerson || '暂无数据'
          }}</el-descriptions-item>
          <el-descriptions-item label="手机号">{{
            item.cVenPhone || '暂无数据'
          }}</el-descriptions-item>

          <el-descriptions-item label="税号">{{
            item.TaxId || '暂无数据'
          }}</el-descriptions-item>
          <el-descriptions-item
            v-for="val in DocumentList"
            :key="val.Id"
            :label="val.DicName"
          >
            <div
              v-for="ele in item.base_ProjectSupplierTypeFilesList"
              :key="ele.Id"
            >
              <el-button
                type="text"
                size="mini"
                @click="openUrl(ele.Url)"
                v-if="ele.Type === val.DicValue"
                >{{ ele.NewFileName }}</el-button
              >
            </div>
          </el-descriptions-item>
        </el-descriptions>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" @click="InfoVisible = false">取 消</el-button>
      </div>
    </el-dialog> -->
    <PersonSelectStep ref="PersonSelectStep" :pId="pId" @save="getDataList" />
    <TreeClassTeam
      ref="TreeClassTeam"
      :pId="pId"
      @save="getDataList"
    ></TreeClassTeam>
  </div>
</template>

<script>
import PersonSelectStep from './PersonSelectStep.vue'
import TreeClassTeam from './TreeClassTeam.vue'
import tools from '@/utils/tools'
import { mapState } from 'vuex'
import moment from 'moment'
export default {
  props: {
    pId: { type: String, require: true },
    parentOBJ: { type: Object },
  },
  components: {
    PersonSelectStep,
    TreeClassTeam,
  },
  data() {
    return {
      moment,
      shareTokenLoading: false,

      shareToken: '',
      downloadUrl: '',
      data: [],
      OutSourceDataList: [],
      localdata: [],
      imageUrl: '', // 新建团队图像
      userName: '', // 名称
      newCreateUser: '',
      dialogVisible: false,
      IsManage: true,
      OutSourceLoading: false,
      loading: false,
      dataLoading: false,
      editVisible: false,
      item: {},
      TreeData: [],
      defaultProps: {
        children: 'children',
        label: 'title',
      },
      EquipmentClassificationIds: [],
      InfoVisible: false,
      DocumentList: [],
    }
  },
  computed: {
    ...mapState(['userInfo']),
  },
  watch: {
    pId: {
      handler(n) {
        if (n) {
          this.getDataList()
          // this.getTreeData()
          // this.getDocumentList()
        }
      },
      immediate: true,
    },
  },
  methods: {
    // 格式化 tooltip 内容，将逗号分隔的字符串转换为数组
    formatTooltipContent(text) {
      if (!text) return []
      return text.split(',').map(item => item.trim()).filter(item => item)
    },
    TreeClassOpen(row) {
      this.$refs.TreeClassTeam.open(row)
    },
    getDocumentList() {
      this.$http
        .post('/Base_ProjectManage/Project_DictionaryMain/GetTheDataByDicKey', {
          Condition: 'DicKey',
          Keyword: 'SupplierType',
        })
        .then((res) => {
          if (res.Success) {
            this.DocumentList = res.Data.DictionaryDetailsList
          }
        })
    },
    async getExcel() {
      await tools.download(
        this.$rootUrl +
          `/Base_ProjectWork/Base_ProjectSupplier/ExportInputOutToExcel?ProjectId=${this.pId}`,
        '供应商信息',
        '.xlsx'
      )
    },
    openUrl(url) {
      window.open(url)
    },
    getUrlType(url) {
      let suffixName = url.split('.').pop()
      if (/(jpg|jpeg|png|GIF|JPG|PNG)$/.test(suffixName)) {
        return true
      } else {
        return false
      }
    },
    formatName(row, column, cellValue, index) {
      if (row.Level == 1) {
        return row.cVenName
      } else if (row.Level == 2) {
        return row.cVenName ? row.cVenName + `（分包）` : ''
      }
    },
    //供应商详情
    ItemInfo(item) {
      this.item = item
      this.InfoVisible = true
    },
    editSave() {
      this.$confirm('是否确认保存?', '提示').then(() => {
        this.$http
          .post('/Base_ProjectWork/Base_ProjectSupplier/SaveProjectSupplier', {
            ProjectId: this.pId,
            SupplierId: [this.item.SupplierId],
            EquipmentClassificationIds: this.EquipmentClassificationIds,
          })
          .then((res) => {
            if (res.Success) {
              this.$notify.success('保存成功')
              this.getDataList()
              this.editVisible = false
            } else {
              this.$notify.error(res.Msg)
            }
          })
      })
    },
    getTreeData() {
      this.$http
        .post(
          '/Base_ProjectWork/Base_Project/GetProjectDevice?ProjectId=' +
            this.pId
        )
        .then((resJson) => {
          if (resJson.Success) {
            this.TreeData = resJson.Data.Data[0].children
          }
        })
    },
    handleCheckChange() {
      this.EquipmentClassificationIds = this.$refs.tree.getCheckedKeys()
    },
    editItem(item) {
      this.$refs.PersonSelectStep.open('编辑供应商', item, true)
      // this.item = item;
      // let Data = [];
      // if (item.EquipmentClassificationIds) {
      //   Data = JSON.parse(item.EquipmentClassificationIds);
      // } else {
      //   Data = [];
      // }
      // this.editVisible = true;
      // this.$nextTick(() => {
      //   this.EquipmentClassificationIds = Data;
      //   if (Data.length > 0) {
      //     this.$refs.tree.setCheckedKeys(Data);
      //   } else {
      //     this.$refs.tree.setCheckedKeys(this.$refs.tree.getCheckedNodes(), false);
      //   }
      // });
    },

    copyValue() {
      let text = `填写资料链接地址：${this.downloadUrl}   邀请码信息：${this.shareToken}  请复制链接后在浏览器中打开，即可填写资料`
      const t = document.createElement('textarea')
      t.nodeValue = text
      t.value = text
      document.body.appendChild(t)
      t.select()
      document.execCommand('copy')
      document.body.removeChild(t)
      this.$notify.success('复制成功')
    },
    copyTEXT(text) {
      const t = document.createElement('textarea')
      t.nodeValue = text
      t.value = text
      document.body.appendChild(t)
      t.select()
      document.execCommand('copy')
      document.body.removeChild(t)
      this.$notify.success('复制成功')
    },
    openTokenInfo(item) {
      this.item = item
      this.getTokenInfo()
    },
    getTokenInfo(isREset = '') {
      this.shareToken = ''
      this.downloadUrl = ''
      this.dialogVisible = true
      this.shareTokenLoading = true
      this.$http
        .post(
          `/Base_BasicData/Base_Supplier/SupGenerateToken?ProjectId=${this.item.ProjectId}&SupId=${this.item.Id}&Reset=${isREset}`
        )
        .then((res) => {
          this.shareTokenLoading = false
          if (res.Success) {
            this.shareToken = res.Data
          } else {
            this.dialogVisible = false
            this.$notify.error(res.Msg)
          }
        })

      this.downloadUrl =
        window.location.origin + '/TemplateLogin?ProjectId=' + this.pId
      // this.downloadUrl = "http://web.devicetest.zytsaas.com/client/device_x64.exe";
    },
    openInfoForm(entity) {
      this.$http
        .post('/Base_ProjectWork/Base_Project/SaveData', entity)
        .then((res) => {
          this.loading = false
          if (res.Success) {
            // 重新调用父组件里的详情
            let Id = this.parentOBJ.entity.Id
            this.parentOBJ.getProjectInfo(Id)
            this.disabled = true
            this.$emit('infoFormClose', true)
            this.$notify.success('操作成功')
          } else {
            this.$notify.error(res.Msg)
          }
        })
    },
    dialogInputConfirm() {},
    delUser(item) {
      this.$confirm('此操作将移除当前供应商,确认继续吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.$http
          .post(
            'Base_ProjectWork/Base_ProjectSupplier/DeleteProjectPartakeUserData',
            {
              UserId: '',
              SupplierId: item.Id,
              ProjectId: item.ProjectId,
            }
          )
          .then((res) => {
            if (res.Success) {
              this.getDataList()
              this.$notify.success('操作成功')
            } else {
              this.$notify.error(res.Msg)
            }
          })
      })
    },
    openDialog(text) {
      this.$refs.PersonSelectStep.open('添加供应商')
    },
    dialogContact(arr) {
      let errArr = []
      let newArr = []
      arr.forEach(async (item) => {
        let idx = this.data.findIndex((im) => {
          return im.SupplierId == item.Id
        })
        if (idx === -1) {
          newArr.push({
            ProjectId: this.pId,
            SupplierId: item.Id,
          })
        } else {
          errArr.push(item)
        }
      })
      if (errArr.length === arr.length) {
        this.$notify.error('选择列表中有已存在该项目下的供应商')
      } else if (errArr.length > 0) {
        this.$notify.warning('选择列表中有重复供应商，筛选保存中')
      }
      if (newArr.length > 0) {
        this.saveUser(newArr)
      }

      // if (newArr.length <= 0) this.$notify.error("成员已存在");
      // else this.saveUser(newArr);
    },
    saveUser(arr) {
      this.dataLoading = true
      this.$http
        .post(
          '/Base_ProjectWork/Base_ProjectSupplier/SaveProjectSupplierData',
          arr
        )
        .then((res) => {
          this.dataLoading = false
          if (res.Success) {
            this.getDataList()
          } else this.$notify.error(res.Msg)
        })
    },
    getDataList() {
      this.dataLoading = true
      this.$http
        .post(
          `/Base_ProjectWork/Base_ProjectSupplier/GetProjectSupplierTree?ProjectId=${this.pId}&Type=1`
        )
        .then((res) => {
          this.dataLoading = false
          if (res.Success) {
            this.data = res.Data
            this.IsManage = this.data.some(
              (item) => item.UserId == this.userInfo.Id && item.IsManage
            )
          }
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.avatar-uploader-icon {
  font-size: 34px;
  color: #8c939d;
  width: 100%;
  height: 90px;
  line-height: 90px;
  text-align: center;
  cursor: pointer;
}

.avatar {
  width: 100%;
  height: 120px;
  display: block;
}

.paddingBox {
  padding: 16px;
  box-sizing: border-box;
}

.team {
  // padding-top: 10px;

  .teamBox {
    margin-right: 10px;
    margin-bottom: 10px;
    // width: 150px;
    // display: flex;

    .badge {
      position: absolute;
      top: 0;
      left: 0;
      background-color: #409eff;
      color: #fff;
      border-bottom-right-radius: 13px;
      font-size: 12px;
      padding: 3px;
      padding-right: 5px;
    }

    .badgeRight {
      position: absolute;
      cursor: pointer;
      bottom: 0;
      right: 0;
      background-color: #aba1a1;
      color: #fff;
      width: 40px;
      text-align: center;
      font-size: 12px;
      padding: 3px;
      padding-right: 5px;
    }
    .share {
      position: absolute;
      cursor: pointer;
      top: 0;
      right: 0;
      background-color: #aba1a1;
      color: #fff;
      text-align: center;
      font-size: 12px;
      padding: 5px;
      padding-right: 5px;
    }

    .badgeRight:hover {
      background: #ec0f31;
    }
    .share:hover {
      background: #409eff;
    }

    .del {
      position: absolute;
      top: 5px;
      right: 5px;
      color: #409eff;
      cursor: pointer;
    }
  }

  .time {
    font-size: 13px;
    color: #999;
  }

  .bottom {
    margin-top: 13px;
    line-height: 12px;
  }

  .button {
    padding: 0;
    float: right;
  }

  .image {
    height: 50px;
    width: 50px;
    // margin: 0 auto;
    display: block;
    border-radius: 50%;
  }

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: '';
  }

  .clearfix:after {
    clear: both;
  }
}

::v-deep .left-box {
  .el-card__header {
    padding: 10px;
    border: none;
  }
}

.ellipsis1 {
  overflow: hidden; //超出隐藏
  word-wrap: break-word;
  word-break: normal;
  text-overflow: ellipsis; //文本超出时显示省略号

  display: -webkit-box;

  -webkit-box-orient: vertical; //子元素排列 vertical（竖排）orhorizontal（横排）

  -webkit-line-clamp: 1; //内容限制的行数
}
// ::v-deep .editTree .el-tree-node__children .el-tree-node {
//   float: left;
// }
::v-deep .el-descriptions-item__label {
  font-size: 16px;
  font-weight: bold;
  width: 20%;
}
::v-deep .el-descriptions-item__content {
  font-size: 14px;
}
::v-deep .el-table .cell {
  position: static;
}

/* 自定义 tooltip 内容样式 - 三列布局 */
.custom-tooltip-content {
  display: grid;
  grid-template-columns: repeat(3, minmax(120px, 1fr));
  gap: 8px 16px;
  max-width: 600px;
  max-height: 300px;
  overflow-y: auto;
  padding: 8px 4px;
  line-height: 1.8;
}

.tooltip-item {
  display: flex;
  align-items: flex-start;
  font-size: 13px;
  line-height: 1.8;
  word-break: break-word;
  padding: 2px 4px;
  color: #fff;
}

.tooltip-icon-square {
  display: inline-block;
  width: 8px;
  height: 8px;
  background-color: #67c23a;
  margin-right: 8px;
  margin-top: 6px;
  flex-shrink: 0;
}

.ellipsis-cell {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
  cursor: default;
}
</style>
